<div class="custom-tooltip">
    <p [innerHtml]="params"></p>
</div>

